// src/pages/Posts/index.js
import React from "react";
import { useParams } from "react-router-dom";
import usePosts from "./usePosts";
import PostCreateForm from "./PostCreateForm";
import PostsTable from "./PostsTable";

import "./index.css";

export default function Posts() {
  const { kind } = useParams();
  const showKind = !["attraction", "policy", "resource", "profile"].includes(kind);
  const pageTitle = kind === "attraction"
    ? "Attractions"
    : kind
      ? `${kind.charAt(0).toUpperCase()}${kind.slice(1)}`
      : "Posts";
  const {
    busy,
    err,
    rows,
    profileSlug,

    newTitle,
    newPostKind,
    createErr,

    setNewTitle,

    onAdd,
    onDeleteLocal,
    canCreate,
    currentKindLimit,
  } = usePosts();

  if (busy) return <div className="posts-page">Loading posts…</div>;
  if (err) return <div className="posts-page" style={{ color: "crimson" }}>{err}</div>;

  return (
    <div className="posts-page">
      <h2 className="posts-title">{pageTitle}</h2>

      {canCreate ? (
        <PostCreateForm
          newTitle={newTitle}
          newPostKind={newPostKind}
          setNewTitle={setNewTitle}
          createErr={createErr}
          onAdd={onAdd}
        />
      ) : (
        <div className="alert alert-info">
          {kind === "attraction"
            ? "Your Free plan includes 0 attractions. Upgrade to add and promote attractions."
            : `Your plan includes ${currentKindLimit} business profile.`}
          {kind === "attraction" && (
            <> <a href="https://bouncehouse.com/businesses#pricing" className="alert-link">View upgrade options</a>.</>
          )}
        </div>
      )}

      <PostsTable
        rows={rows}
        onDeleteLocal={onDeleteLocal}
        showKind={showKind}
        showStatus={kind === "attraction"}
        showPreview
        kind={kind}
        profileSlug={profileSlug}
      />
    </div>
  );
}
